import styled from 'styled-components';

export const CheckboxWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding-left: 20px;
`;

export const IdField = styled.div`
  vertical-align: top;
`;
